import { Placement } from 'react-joyride';
import { BaseTour } from '../BaseTour';

export class RateCardTableTour extends BaseTour {
  id = 'rate-card-table';

  content = 'Rate Card Manager - Shipping Services Table';

  placement: Placement = 'bottom';

  steps = {
    shippingServicesTable: () => ({
      content:
        'This table displays all shipping services for the selected provider — including: Modality, Trade Lane, Shipper/Consignee, Billed Entity, Service Type, Carrier, Incoterm, Lead Time, and Created On. **Click on any row to continue the tour and explore charge management features.**',
      placement: 'bottom' as Placement,
      disableBeacon: true,
    }),

    columnFilters: () => ({
      content:
        'Each column supports filtering. Click the filter icon in any column header to see all unique values, select the ones you want to display, and click Apply. Active filters show a green icon with a counter like "2/5". Use Select All or Clear for quick actions.',
      placement: 'bottom' as Placement,
    }),

    paginationShippingServices: () => ({
      content: 'Use the pagination controls to navigate through shipping services. Choose to display 100, 500, or 1,000 rows per page.',
      placement: 'top' as Placement,
    }),

    chargeDetailsSheet: () => ({
      content:
        'Click on any shipping service row to open the Charge Details panel below. This is where you manage validity periods and individual charges for that service.',
      placement: 'top' as Placement,
    }),
  } as const;
}
